var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.383,
    height: 25.75,
    viewBox: "0 0 19.383 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11295",
    "data-name": "Group 11295",
    transform: "translate(0.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1865",
    "data-name": "Ellipse 1865",
    className: "cls-1",
    cx: 2.344,
    cy: 2.344,
    r: 2.344,
    transform: "translate(6.906 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    className: "cls-2",
    d: "M12.972,140.1h5.711v22.675H.8V140.1H6.511",
    transform: "translate(-0.3 -137.775)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1866",
    "data-name": "Ellipse 1866",
    className: "cls-2",
    cx: 5.007,
    cy: 5.007,
    r: 5.007,
    transform: "translate(4.278 8.047)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1149",
    "data-name": "Line 1149",
    className: "cls-2",
    x2: 10.014,
    transform: "translate(4.278 20.207)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1150",
    "data-name": "Line 1150",
    className: "cls-2",
    x2: 10.014,
    transform: "translate(4.278 22.711)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorPhone);
export default __webpack_public_path__ + "static/media/doorPhone.5aef5b77e297f2b1460469065c716be8.svg";
export { ForwardRef as ReactComponent };